import axiosInstance from "../../utils/AxiosInstance";

export const removeJob = async (id) => {
  const response = await axiosInstance.delete(`/jobs/${id}`);
  return response.data;
};
export const editJob = async (data) => {
  const response = await axiosInstance.patch(`/jobs/${data.id}`, data);
  return response.data;
};
export const addJob = async (data) => {
  const response = await axiosInstance.post(`/jobs`, data);
  return response.data;
};
